import { WithChildren } from '@config';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './Unauthenticated.module.scss';

export function Unauthenticated({ children }: WithChildren): ReactElement {
  const { t } = useTranslation();

  return <div className={styles.container}>{t(`Authentication is in progress...`)}</div>;
}
